<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="appType" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('APP类型') }}<template slot="title">{{ $t('APP类型') }}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.appType" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.VersionAppTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="upNotes" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('更新说明') }}<template slot="title">{{ $t('更新说明') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.upNotes" :maxLength="300" :placeholder="$t('请输入')+$t('更新说明')" />
      </a-form-model-item>
      <a-form-model-item prop="upHeSize" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('更新包大小') }}<template slot="title">{{ $t('更新包大小') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.upHeSize" :placeholder="$t('请输入')+$t('更新包大小')" />
      </a-form-model-item>
      <a-form-model-item prop="versionName" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('版本号名称') }}<template slot="title">{{ $t('版本号名称') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.versionName" :maxLength="10" :placeholder="$t('请输入')+$t('版本号名称')" />
      </a-form-model-item>
      <a-form-model-item prop="versionCode" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('版本号') }}<template slot="title">{{ $t('版本号') }}</template>
          </a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.versionCode" :maxLength="10" :placeholder="$t('请输入')+$t('版本号')" />
      </a-form-model-item>
      <a-form-model-item prop="upType" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('更新类型') }}<template slot="title">{{ $t('更新类型') }}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.upType" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.VersionUpTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="compulsoryUp" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('强制升级') }}<template slot="title">{{ $t('强制升级') }}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.compulsoryUp" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.CompulsoryUpEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="downloadUrl" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('下载地址') }}<template slot="title">{{ $t('下载地址') }}</template>
          </a-tooltip>
        </span>
        <a-upload
          name="downloadUrl"
          :multiple="false"
          listType="picture-card"
          :show-upload-list="false"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.downloadUrl"
            :src="form.downloadUrl"
            :alt="form.downloadUrl"
            style="height: 102px; width: 102px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('上传') }}</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVersionInfo, addVersionInfo, updateVersionInfo } from '@/api/appversion/versionInfo'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { uploadObject, uploadOss } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        appType: null,

        upNotes: null,

        upHeSize: null,

        upUrlType: null,

        upUrl: null,

        versionName: null,

        versionCode: null,

        upType: null,

        compulsoryUp: null,

        downloadUrl: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        appType: [
          { required: true, message: this.$t('APP类型') + this.$t('不能为空'), trigger: 'change' }
        ],
        upUrlType: [
          { required: true, message: this.$t('更新类型') + this.$t('不能为空'), trigger: 'change' }
        ],
        versionCode: [
          { required: true, message: this.$t('版本号') + this.$t('不能为空'), trigger: 'blur' }
        ],
        upType: [
          { required: true, message: this.$t('更新类型') + this.$t('不能为空'), trigger: 'change' }
        ],
        compulsoryUp: [
          { required: true, message: this.$t('强制升级') + this.$t('不能为空'), trigger: 'blur' }
        ],
        downloadUrl: [
          { required: true, message: this.$t('下载地址') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        appType: null,
        upNotes: null,
        upHeSize: null,
        upUrlType: null,
        upUrl: null,
        versionName: null,
        versionCode: null,
        upType: null,
        compulsoryUp: null,
        downloadUrl: null,
        createTime: null,
        remark: null
      }
    },

    // oss 上传开始
    async handlePreview(file) {
      const suffix = file.name.substring(file.name.lastIndexOf('.'))
      if (suffix === '.mp4') {
        this.handleVideoPreview(file)
      } else {
        this.handleImagePreview(file)
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 100
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 100MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'wgt'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'downloadUrl', res)
          _this.$message.success(this.$t('上传成功'))
        })
      })
    },
    // oss 上传结束
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVersionInfo({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateVersionInfo(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addVersionInfo(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
